import React from 'react';
import {
  LandingHero,
  PainPoints,
  SolutionFeatures,
  TargetAudience,
  LandingPricing,
  LandingFAQ,
  Header,
  LandingStats,
  HowItWorks,
  StickyCTA,
  Footer,
  VkIntegration,
  YandexIntegration,
} from 'widgets';

export const AboutPage: React.FC = () => {
  return (
    <>
      <Header transparent />
      <LandingHero />
      <LandingStats />
      <PainPoints />
      <HowItWorks />
      <SolutionFeatures />
      <YandexIntegration />
      <VkIntegration />
      <TargetAudience />
      <LandingPricing />
      <LandingFAQ />
      <Footer />
      <StickyCTA />
    </>
  );
};
